import React from "react";
import "./NormalTourPackage.css";
import { Link } from "react-router-dom";
import ntmanali from "../../assets/ntmanali.jpg";
import ntagra from "../../assets/ntagra.jpg";
import ntjaipur from "../../assets/ntjaipur.jpg";
import { useNavigate } from "react-router-dom";
const NormalTourPackage = () => {
  // Array of Objects
  const packages = [
    {
      id: 1,
      title: "Manali",
      duration: "7 Days - All-Inclusive",
      badge: "Popular",
      image: ntmanali,
      link: "/tour-package-data",
    },
    {
      id: 2,
      title: "Agra",
      duration: "5 Days - Adventure",
      badge: "Top Rated",
      image: ntagra,
      link: "/tour-package-data",
    },
    {
      id: 3,
      title: "Jaipur",
      duration: "3 Days - Cultural",
      badge: "Bestseller",
      image: ntjaipur,
      link: "/tour-package-data",
    },
  ];
  const navigate = useNavigate();
  return (
    <div className="tour-main">
      {/* Header */}
      <div className="tour-header-normal">
        <h1>Normal Tour Package</h1>
        <Link to="/normal-tour-view-more">
          <button className="view-btn">View More</button>
        </Link>
      </div>

      {/* Cards */}
      <div className="tour-grid">
        {packages.map((item) => (
          <div
            className="tour-card"
            key={item.id}
            onClick={() =>
              navigate(item.link, {
                state: { title: item.title },
              })
            }
          >
            <div className="img-box">
              <span className="badge">{item.badge}</span>
              <img src={item.image} alt={item.title} />
            </div>
            <div className="card-content">
              <h3>{item.title}</h3>
              <p>{item.duration}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NormalTourPackage;
